export const parseDateValue = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  
  const parsed = new Date(value);
  return isNaN(parsed.getTime()) ? null : parsed;
};

export const getEffectiveVisitDate = (selectedDate, selectedTimeSlot, selectedTickets = []) => {
  const directDate = parseDateValue(selectedDate);
  if (directDate) return directDate;

  const slotDate = parseDateValue(selectedTimeSlot?.startDateTime || selectedTimeSlot?.date);
  if (slotDate) return slotDate;

  const ticketWithDate = selectedTickets.find(ticket => 
    ticket?.selectedDate || ticket?.selectedEventTime?.startDateTime
  );
  if (ticketWithDate) {
    return parseDateValue(ticketWithDate.selectedDate || ticketWithDate.selectedEventTime?.startDateTime);
  }

  return null;
};

export const isToddlerSpecialUpsell = (name = '') => {
  return typeof name === 'string' && name.toLowerCase().includes("toddler special");
};

export const isToddlerRestrictedDate = (date) => {
  const dateObj = parseDateValue(date);
  if (!dateObj) return false;

  const month = dateObj.getMonth(); // 0-indexed (0 = January)
  const day = dateObj.getDate();

  if (month === 10) { // November
    return day === 29 || day === 30;
  }

  if (month === 11) { // December
    return [6, 7, 8, 13, 14, 20, 21, 22, 23, 24].includes(day);
  }

  return false;
};

